import { render, staticRenderFns } from "./FieldAddTask.vue?vue&type=template&id=59fcf286&scoped=true&"
import script from "./FieldAddTask.vue?vue&type=script&lang=js&"
export * from "./FieldAddTask.vue?vue&type=script&lang=js&"
import style0 from "./FieldAddTask.vue?vue&type=style&index=0&id=59fcf286&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcf286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
